"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsDeliveryItem = void 0;
const react_1 = require("react");
const isDeliverySalesOrderItem_1 = require("../helpers/isDeliverySalesOrderItem");
/**
 * Helper hook to determine whether the given product is the delivery one
 *
 * Used in many places and can be expensive without using a memo
 */
const useIsDeliveryItem = (item, deliveryProductId) => (0, react_1.useMemo)(() => (0, isDeliverySalesOrderItem_1.isDeliverySalesOrderItem)(item, deliveryProductId), [
    item,
    deliveryProductId
]);
exports.useIsDeliveryItem = useIsDeliveryItem;
//# sourceMappingURL=useIsDeliveryItem.js.map